import ReactComponent from '../app/ReactComponent'
import {Space, Layout, Row, Col, Image} from 'antd'
import {Menu} from '../components/layout/Menu'
import {Link, useLocation} from 'react-router-dom'
import {getQueryParameter} from '../helpers/global'
import Logo from '../image/logo-desktop.svg'
import {ReactComponent as LogoPortalDarce} from '../image/logo-portal-darce.svg'
import {ReactComponent as LeftCircle} from '../image/left-circle.svg'
import {LoyaltyStatusTag} from '../components/loyalty-status/LoyaltyStatusTag'
import {getLoyaltyStatus} from '../services/properties'

export class Header extends ReactComponent {
  state = {
    hideMenu: false,
    path: "",
    loyalty_status: null
  }

  async componentDidMount() {

    void this.updateState({
      path: this.props.path,
      hideMenu: (getQueryParameter("isHideMenu") || "").toLowerCase() === "true"
    })

    if(this.props.$auth.is_authorized)
      void this.getLoyaltyStatus()

  }

  async componentDidUpdate(prevProps) {

    if(this.props.$auth.is_authorized && !prevProps.$auth.is_authorized)
      void this.getLoyaltyStatus()

  }

  getLoyaltyStatus = async () => {
    const loyalty_status = await getLoyaltyStatus(await this.$app.$store('account').getProperties())

    void this.updateState({
      loyalty_status
    })

  }

  render() {
    return (
      <Layout tagName="header" className={`header ${this.state.hideMenu && "hidden"}`}>
        <Row align="center">
          <Col xs={24}>
            <Space size={[0, 0]} style={{display: "flex"}} className="header-space">


              <Link to="/" className={`amber-logo logo ${this.props.path !== "/" ? "is-not-root-path" : ""}`}>
                <img alt="" className="logo-svg" src={Logo}/>
                <span className="dib back-to-home"><LeftCircle className="_secondary-stroke"/><span className="_secondary-text">Zpět na portál dárce</span></span>
              </Link>
              <div className="header-logo-spacer"></div>


              <Link to="/" className="logo header-portal-logo">
                <LogoPortalDarce/>
              </Link>

              <div className="header-actions">
                {this.props.$auth.is_authorized ?
                  <>
                    <LoyaltyStatusTag status={this.state.loyalty_status} linkTo="/rewards"/>
                    <Menu $auth={this.props.$auth}/>
                  </>
                  :
                  <div style={{width: 32, height: 1}}></div>}
              </div>
            </Space>
          </Col>
        </Row>
      </Layout>
    )
  }
}

export function HeaderHOC ({$auth}) {
  const location = useLocation()

  return <Header $auth={$auth} path={location.pathname}/>
}